import React, { useEffect, useState } from "react";
import {
  FaFacebook,
  FaInstagram,
  FaTwitter,
  FaYoutube,
  FaTiktok,
  FaLinkedin,
  FaPinterest,
} from "react-icons/fa";

function Footers() {
  // const [termsUrl, setTermsUrl] = useState("/Terms.pdf");
  useEffect(() => {
    const iframeData = document.getElementById("iframeId");
    
    const lat = 44.79776704978071;
    const lon = -106.95496542866071;
    iframeData.src = `https://maps.google.com/maps?q=${lat},${lon}&hl=es;&output=embed`;
  }, []);
  const date=new Date();
  return (
    <div>
      <footer aria-label="Site Footer" className="bg-[#22223d] text-white py-10">
        <div className="py-10 mx-auto space-y-8 sm:px-6 lg:space-y-8 lg:px-16">
          <div className="grid lg:px-2 px-6 grid-cols-1 xs:gap-6 lg:grid-cols-3">
            <div>
              <img
                className="w-[15%]"
                src="newimage/logoenglish.png"
                alt="Logo"
              />
              <p className="max-w-xs mt-4 text-gray-200">
                30 N Gould St Ste N, Sheridan, WY, 82801, US
              </p>

              <div className="flex flex-wrap gap-6 mt-3 sm:mt-8">
                {/* Social Media Links */}
                <div className="flex flex-col space-y-4">
                  <a
                    href="https://www.facebook.com/profile.php?id=61570855943243"
                    rel="noreferrer"
                    target="_blank"
                    className="text-gray-200 transition no-underline hover:opacity-75 flex items-center gap-2"
                  >
                    <FaFacebook /> Facebook
                  </a>
                  <a
                    href="https://www.youtube.com/@RadeBjelan"
                    rel="noreferrer"
                    target="_blank"
                    className="text-gray-200 transition no-underline hover:opacity-75 flex items-center gap-2"
                  >
                    <FaYoutube /> YouTube
                  </a>
                  <a
                    href="https://www.youtube.com/channel/UC9OW-OSi96oVe5k9vndQoaQ"
                    rel="noreferrer"
                    target="_blank"
                    className="text-gray-200 transition no-underline hover:opacity-75 flex items-center gap-2"
                  >
                    <FaYoutube /> YouTube (Channel 2)
                  </a>
                  <a
                    href="https://www.tiktok.com/@radebjelan"
                    rel="noreferrer"
                    target="_blank"
                    className="text-gray-200 transition no-underline hover:opacity-75 flex items-center gap-2"
                  >
                    <FaTiktok /> TikTok
                  </a>
                </div>
                <div className="flex flex-col space-y-4">
                  <a
                    href="https://www.linkedin.com/in/bjelan/"
                    rel="noreferrer"
                    target="_blank"
                    className="text-gray-200 transition no-underline hover:opacity-75 flex items-center gap-2"
                  >
                    <FaLinkedin /> LinkedIn
                  </a>
                  <a
                    href="https://x.com/bjelanr"
                    rel="noreferrer"
                    target="_blank"
                    className="text-gray-200 transition no-underline hover:opacity-75 flex items-center gap-2"
                  >
                    <FaTwitter /> Twitter/X
                  </a>
                  <a
                    href="https://www.pinterest.com/Rade_Bjelan"
                    rel="noreferrer"
                    target="_blank"
                    className="text-gray-200 transition no-underline hover:opacity-75 flex items-center gap-2"
                  >
                    <FaPinterest /> Pinterest
                  </a>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 gap-1 sm:grid-cols-2 lg:col-span-2 lg:grid-cols-4">
              <div>
                <p className="font-medium text-gray-100">Company</p>
                <nav
                  aria-label="Footer Navigation - Company"
                  className="mt-2 sm:mt-6"
                >
                  <ul className="space-y-4 text-sm">
                    <li>
                      <a
                        href="/about"
                        className="text-gray-200 transition no-underline hover:opacity-75"
                      >
                        About
                      </a>
                    </li>
                  
                  
                  </ul>
                </nav>
              </div>

              <div>
                <p className="font-medium text-lg text-gray-200">
                  Helpful Links
                </p>
                <nav
                  aria-label="Footer Navigation - Company"
                  className="mt-2 sm:mt-6"
                >
                  <ul className="space-y-4 text-sm">
                    <li>
                      <a
                        href="/contact"
                        className="text-gray-200 transition no-underline hover:opacity-75"
                      >
                        Contact
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="text-gray-200 transition no-underline hover:opacity-75"
                      >
                        FAQs
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="text-gray-200 transition no-underline hover:opacity-75"
                      >
                        Live
                      </a>
                    </li>
                    <li>
                      <a
                        // href={termsUrl}
                        href="/temrs&conditions"
                      
                        className="text-gray-200 transition no-underline hover:opacity-75"
                      
                        rel="noopener noreferrer"
                      >
                        Terms and Conditions
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>

              <div className="">
                <p className="font-medium text-lg text-gray-200 mb-2">
                  Follow Map
                </p>
                <iframe id="iframeId" height="200px" width="100%"></iframe>
              </div>
            </div>
          </div>
        </div>
        
        <p className="text-xs text-center pb-4 text-gray-100">
          &copy;Rade Bjelan <span>{date.getFullYear()}</span> Design and Developed By{" "}
          <a className="hover:text-red-500" target="_blank" href="https://5techg.com/">
            5TechG
          </a>
          .
        </p>
      </footer>
    </div>
  );
}

export default Footers;
